<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>

<div class="dash">
  <div class="load_top">
    <!-- <button
      type="button"
      *ngIf="commericial"
      [disabled]="commercialLoadDetails?.load_category"
      [ngStyle]="{
        opacity: commercialLoadDetails?.load_category ? '0.5' : '1'
      }"
      [ngClass]="{ 'disabled-button': commercialLoadDetails?.material_type }"
      class="button buttonBlue fixed-btn"
      (click)="addLoad('New', null)"
    >
      <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
      Add
    </button>
    <button
      type="button"
      *ngIf="non_commericial"
      [disabled]="nonCommercialLoad?.load_category"
      [ngStyle]="{
        opacity: nonCommercialLoad?.load_category ? '0.5' : '1'
      }"
      [ngClass]="{ 'disabled-button': nonCommercialLoad?.material_type }"
      class="button buttonBlue fixed-btn"
      (click)="addLoad('New', null)"
    >
      <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
      Add
    </button> -->
    <div class="search_toggle" *ngIf="searchButton">
      <button
        type="button"
        class="button search-btn fixed-btn"
        (click)="openSearch()"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>
    </div>
    <div class="search_toggle" *ngIf="toggleSearch">
      <input
        class="search pl-2"
        placeholder="Search Category"
        id="searchLoadType"
        style="text-transform: capitalize"
        [(ngModel)]="search_Number"
        [ngModelOptions]="{ standalone: true }"
        #newItem
        (keyup)="onInputChange(newItem.value)"
        (keyup.enter)="isInputValid && search(newItem.value)"
      />
      <button
        [disabled]="!isInputValid"
        *ngIf="search_Btn"
        class="search_number"
        (click)="search(newItem.value)"
      >
        <img src="../../../assets/img/search-white.svg" />
      </button>

      <button
        type="button"
        *ngIf="clear_Btn"
        class="clear_number"
        (click)="resetTruckTrackInfo()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <path
            d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
          />
        </svg>
      </button>
    </div>
  </div>
  <div class="dash-loads-top1">
    <p>Goods Type</p>
    <div class="dash-loads-tabs">
      <a
        [ngClass]="{ active: loadType == 'Commercial' }"
        (click)="getLoadsList('Commercial')"
        >Commercial</a
      >
      <a
        [ngClass]="{ active: loadType == 'Non-Commercial' }"
        (click)="getLoadsList('Non-Commercial')"
        >Non-Commercial</a
      >
    </div>
  </div>
  <div class="dash-loads-category" *ngIf="loadType == 'Commercial'">
    <div [class.spinner]="loading"></div>

    <p>
      Goods Category
      <span class="edit-img-span">
        <img
          src="../../../assets/img/edit icon.png"
          class="editimg"
          (click)="addLoad('Edit', commercialLoadDetails)"
        />
      </span>
    </p>
    <div *ngIf="!(commercialLoadDetails?.material_type.length > 0)">
      <p>No data found</p>
    </div>
    <div
      class="loads-category"
      *ngFor="let item of commercialLoadDetails?.material_type; let i = index"
    >
      <a type="button">
        <p>{{ item.name }} (HSN: {{ item.hsn_code }})</p>
      </a>
      <button>
        <img
          class="del"
          matTooltip="Delete Load"
          matTooltipPosition="above"
          src="../../../assets/img/delete-black.svg"
          (click)="deleteLoadDetails(commercialLoadDetails, i)"
        />
      </button>
    </div>
  </div>
  <div class="dash-loads-category" *ngIf="loadType == 'Non-Commercial'">
    <p>
      Goods Category
      <span class="edit-img-span">
        <img
          src="../../../assets/img/edit icon.png"
          class="editimg"
          (click)="addLoad('Edit', nonCommercialLoad)"
        />
      </span>
    </p>
    <div *ngIf="!(nonCommercialLoad?.material_type.length > 0)">
      <p>No data found</p>
    </div>
    <div
      class="loads-category"
      *ngFor="let item of nonCommercialLoad?.material_type; let i = index"
    >
      <a type="button">
        <p>{{ item.name }} (HSN: {{ item.hsn_code }})</p>
      </a>
      <button>
        <img
          class="del"
          matTooltip="Delete Load"
          matTooltipPosition="above"
          src="../../../assets/img/delete-black.svg"
          (click)="deleteLoadDetails(nonCommercialLoad, i)"
        />
      </button>
    </div>
  </div>
  <div *ngIf="last_page && last_page > 1" class="pagination">
    <button class="btn" [disabled]="fetch_page == 1" (click)="pagination('-1')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>
    <button
      class="btn"
      [disabled]="fetch_page == 1"
      (click)="pagination('first')"
    >
      <img
        src="../../../assets/img/pagination-left.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <div class="pages">
      <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
    </div>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('last')"
    >
      <img
        src="../../../assets/img/pagination-right.svg"
        alt=""
        class="btn--icon"
      />
    </button>
    <button
      class="btn"
      [disabled]="last_page == fetch_page"
      (click)="pagination('1')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="btn--icon"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap=" round"
          stroke-linejoin="round"
          d="M9 5l7 7-7 7"
        />
      </svg>
    </button>
  </div>
</div>
